<template>
    <div>
      <vx-card class="w-full">
        <div class="flex justify-between items-center">
          <h4>{{ label }}</h4>
          <vs-button color="secondary" @click="onClickSave">등록</vs-button>
        </div>

        <!-- 기본정보 -->
        <FieldSelectModule
          title="작성자 정보"
          v-model="form.stdInfo"
          :typeslabel="{
            date: '등록일',
          }"
          :board="board"
          :types="['department', 'com_name', 'rank', 'writer_name', 'date']"
          class="mt-28px"
        />

        <!-- 파일 업로드 -->
        <div class="mt-28px">
          <div class="writeGridContainer">
            <div class="writeGridLineItem">
              <div>파일 업로드</div>
              <div>
                <vs-button color="secondary" type="border" :href="excelLink">엑셀 템플릿 다운로드</vs-button>
                <vs-button color="secondary" class="ml-2" @click="onClickExcelUpload"> 작성 엑셀 업로드 </vs-button>
                <input v-show="false" ref="excelInput" type="file" multiple @change="readFile" accept="application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" />
              </div>
            </div>
          </div>
        </div>
        <div class="flex justify-between items-center mt-6 mb-4">
          <h5><i class="dot"></i> 등록 대상 시설물 정보</h5>
        </div>

        <div>
          <table class="excel-table">
            <colgroup>
              <col width="50" />
              <col width="60" />
              <col width="400" />
              <col v-for="_ in 7" :key="`col_${_}`" />
              <col width="120" />
            </colgroup>
            <thead>
              <tr>
                <th></th>
                <th>No.</th>
                <th>관리 부서 및 업체 지정</th>
                <th>시설물번호</th>
                <th>관리번호</th>
                <th>시설물명</th>
                <th>관리주체</th>
                <th>소유자</th>
                <th>전화번호</th>
                <th>보관자</th>
                <th>수정/삭제</th>
              </tr>
            </thead>
            <tbody v-for="(excel, excel_i) in excelData" :key="`${excel_i}_${excel[0]}`">
              <tr>
                <td>
                  <img src="@/assets/icons/triangle_down.svg" class="mx-auto duration-200 cursor-pointer" :style="{ transform: excel.open ? 'rotate(0deg)' : 'rotate(-90deg)' }" @click="excel.open = !excel.open" />
                </td>
                <td>{{ excel_i + 1 }}</td>
                <td v-for="(col, col_key) in excel.row" :key="`${excel_i}_td_${col_key}`">
                  <div v-if="editExcelIndex === excel_i" class="p-1">
                    <CompanySelector v-if="col_key === '관리부서및업체지정'" multiple class="w-full" v-model="excel.row[col_key]" />
                    <ml-input v-else-if="col_key === '시설물번호'" v-model="excel.form.facilityNumber" class="w-full" />
                    <ml-input v-else-if="col_key === '관리번호'" v-model="excel.form.managementNumber" class="w-full" />
                    <ml-input v-else-if="col_key === '시설물명'" v-model="excel.form.facilityName" class="w-full" />
                    <ml-input v-else-if="col_key === '관리주체'" v-model="editExcelData.form.management_entry" class="w-full" />
                    <ml-input v-else-if="col_key === '소유자'" v-model="excel.form.owner" class="w-full" />
                    <ml-input v-else-if="col_key === '전화번호'" v-model="excel.form.phoneNumber" class="w-full" />
                    <ml-input v-else-if="col_key === '보관자'" v-model="excel.form.curstodian" class="w-full" />
                    <ml-input v-else v-model="editExcelData.row[col_key]" class="w-full" />
                  </div>
                  <div v-else>
                    <div class="flex items-center justify-center gap-2">
                      <CompanySelector v-if="col_key === '관리부서및업체지정'"  multiple class="w-full" v-model="excel.row[col_key]" :show-empty-message="true" />
                      <p v-else-if="col_key === '시설물번호'">{{ excel.form.facilityNumber || "-" }}</p>
                      <p v-else-if="col_key === '관리번호'">{{ excel.form.managementNumber || "-" }}</p>
                      <p v-else-if="col_key === '시설물명'">{{ excel.form.facilityName || "-" }}</p>
                      <p v-else-if="col_key === '관리주체'">{{ excel.form.management_entity || "-" }}</p>
                      <p v-else-if="col_key === '소유자'">{{ excel.form.owner || "-" }}</p>
                      <p v-else-if="col_key === '전화번호'">{{ excel.form.phoneNumber || "-" }}</p>
                      <p v-else-if="col_key === '보관자'">{{ excel.form.custodian || "-" }}</p>
                      <p v-else>{{ col || "-" }}</p>
                    </div>
                    <p v-if="excel.err && excel.err[col_key]" class="errMsg">{{ excel.err[_num_i] }}</p>
                  </div>
                </td>
                <td>
                  <div class="flex justify-center gap-3">
                    <fragment v-if="editExcelIndex === excel_i">
                      <button @click="onClickFinishExcelData(excel_i)">
                        <feather-icon icon="CheckIcon" svgClasses="h-5 w-5" />
                      </button>
                      <button @click="onClickCancelExcelData(excel_i)">
                        <feather-icon icon="XIcon" svgClasses="h-5 w-5" />
                      </button>
                    </fragment>
                    <fragment v-else>
                      <button v-if="false" @click="onClickEditExcelData(excel_i)">
                        <feather-icon icon="Edit2Icon" svgClasses="h-5 w-5" />
                      </button>
                      <button @click="onClickRemoveExcelData(excel_i)">
                        <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5" />
                      </button>
                    </fragment>
                  </div>
                </td>
              </tr>
              <tr v-show="excel.open">
                <td colspan="11" class="p-0">
                  <ComplexWriteBody :form="excel.form" :init-cat1-list="cat1List" :category-info="excel.categoryInfo" />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </vx-card>
    </div>
  </template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FieldFacilityBridgeWrite from "@/views/_BS/FieldFacilityBridgeWrite.vue";
import CompanySelector from "@/components/selector/CompanySelector.vue";
import ComplexWriteBody from "@/views/fields/template/ComplexWriteBody.vue";

import XLSX from "xlsx";
import DateUtil from "@/util/DateUtil";
import config from "/public/config";
import {levenshteinDistance} from "@/util/DataUtil";

export default {
  props: {
    label: String,
  },
  components: {
    FieldSelectModule,
    FieldFacilityBridgeWrite,
    CompanySelector,
    ComplexWriteBody,
  },
  data() {
    return {
      board: {
        projectTitle: this.$store.state.project.projectInfo.field_name,
        writer: {}, //작성자 정보
        readonly: false, // 읽기전용인가
        isPrint: false,
        viewSaveBtn: true,
        viewRemoveBtn: true,
      },
      form: {
        stdInfo: {},
      },

      excelData: [],

      editExcelIndex: null,
      editExcelData: null,

      cat1List: [],
    };
  },
  computed: {
    projectId() {
      return Number(this.$route.params.proj_id);
    },
    boardId() {
      return Number(this.$route.name.slice(-3));
    },
    myInfo() {
      return this.$store.state.member.memberInfo;
    },
    excelLink() {
      return `${config.BASE_API_URL}/storage/app/media/%EC%8B%9C%EC%84%A4%EB%AC%BC%EA%B4%80%EB%A6%AC%EB%8C%80%EC%9E%A5_%EA%B1%B4%EC%B6%95%EB%AC%BC.xls`;
    },
  },
  async mounted() {
    await this.init();
  },
  methods: {
    async init() {
      await this.$store.dispatch("USER_INFO");
      this.board.writer = {
        id: this.$store.state.auth.userInfo.id,
        name: this.$store.state.auth.userInfo.name,
        company_id: this.$store.state.auth.userInfo.company_id,
        department: this.$store.state.auth.userInfo.department,
        section: this.$store.state.auth.userInfo.section,
        rank: this.$store.state.auth.userInfo.rank,
        com_name: "",
      };

      await this.$store.dispatch("company/LOAD_COMPANY", {
        companyId: this.board.writer.company_id,
      });
      this.board.writer.com_name = this.$store.state.company.companyInfo.com_name;
      if (!this.board.writer.section) {
        this.board.writer.section = this.board.writer.com_name;
      }

      // 시설물 구분 값을 불러온다
      const response = await this.$store.dispatch("project/LOAD_FIELD_FACILITY_CATEGORY_LIST", {});
      if (response.data) {
        this.facilityCategoryList = response.data;
        const _cat1List = this.facilityCategoryList.map((item) => item.cat1);
        const uniqueCat1List = [...new Set(_cat1List)];
        this.cat1List = this.setCatOther(uniqueCat1List);
      }
    },

    /**
       * 주어진 cat1과 cat3에 가장 가까운 시설 카테고리를 찾는 함수입니다.
       * 이 함수는 레벤슈타인 거리(Levenshtein Distance)를 사용하여 cat3와 각 시설 카테고리 간의 '편집 거리'를 계산하고,
       * 가장 작은 편집 거리를 가진 시설 카테고리를 반환합니다.
       *
       * @param {string} cat1 - 시설 카테고리의 첫 번째 분류
       * @param {string} cat3 - 시설 카테고리의 세 번째 분류
       * @returns {Object} cat3와 가장 가까운 시설 카테고리
       */
    findFacilityCategory(cat1, cat3) {
      let cat1Items = this.facilityCategoryList.filter((item) => item.cat1 === cat1);
      if (cat1Items.length === 0) {
        cat1Items = this.facilityCategoryList;
      }

      return cat1Items.reduce((prev, curr) => {
        const prevDistance = levenshteinDistance(cat3, prev.cat3);
        const currDistance = levenshteinDistance(cat3, curr.cat3);
        return (prevDistance < currDistance) ? prev : curr;
      });
    },

    onClickExcelUpload() {
      const excelInput = this.$refs.excelInput;
      excelInput.value = null;
      excelInput.click();
    },
    // 엑셀데이터 파싱
    async readFile(event) {
      // get File object from input tag
      for (let i = 0; i < event.target.files.length; i++) {
        const file = event.target.files[i];
        // declare FileReader, temp result
        const reader = new FileReader();
        const tmpResult = {};

        // if you use "this", don't us   e "function(e) {...}"
        reader.onload = async (e) => {
          let data = e.target.result;
          data = new Uint8Array(data);

          // get excel file
          const excelFile = XLSX.read(data, { type: "array", cellDates: true });
          const sheetData = excelFile.Sheets[excelFile.SheetNames[0]];


          let 관리주체구분 = "";
          if (this.getCellData(sheetData, "AI23")) {
            관리주체구분 = "민간";
          } else if (this.getCellData(sheetData, "Y25")) {
            관리주체구분 = "중앙부처";
          } else if (this.getCellData(sheetData, "AC25")) {
            관리주체구분 = "지자체";
          } else if (this.getCellData(sheetData, "AG25")) {
            관리주체구분 = "(국가/지방)공기업";
          }

          let 소유자구분 = "";
          if (this.getCellData(sheetData, "BB23")) {
            소유자구분 = "민간";
          } else if (this.getCellData(sheetData, "AQ25")) {
            소유자구분 = "중앙부처";
          } else if (this.getCellData(sheetData, "AW25")) {
            소유자구분 = "지자체";
          } else if (this.getCellData(sheetData, "AY25")) {
            소유자구분 = "(국가/지방)공기업";
          }

          const addresses = [];
          if (this.getCellData(sheetData, "B22")) addresses.push(this.getCellData(sheetData, "B22"));
          if (this.getCellData(sheetData, "C22")) addresses.push(this.getCellData(sheetData, "C22"));
          if (this.getCellData(sheetData, "H22")) addresses.push(this.getCellData(sheetData, "H22"));
          if (this.getCellData(sheetData, "O22")) addresses.push(this.getCellData(sheetData, "O22"));
          if (this.getCellData(sheetData, "O24")) addresses.push(this.getCellData(sheetData, "O24"));

          const 전화번호 = this.getCellData(sheetData, "AH14").replace(/ /g, "").replace("전화번호:", "");

          const cat1 = this.getCellData(sheetData, "AS20");
          const cat3 = this.getCellData(sheetData, "AI20");
          const facilityCategory = this.findFacilityCategory(cat1, cat3);

          this.excelData.push({
            open: false,
            err: [],
            row: {
              관리부서및업체지정: "",
              시설물번호: this.getCellData(sheetData, "X4"),
              관리번호: this.getCellData(sheetData, "X5"),
              시설물명: this.getCellData(sheetData, "X6"),
              관리주체: this.getCellData(sheetData, "W13"),
              소유자: this.getCellData(sheetData, "W14"),
              전화번호,
              보관자: this.getCellData(sheetData, "W15")
            },

            form: {
              phoneNumber: 전화번호,
              custodian: this.getCellData(sheetData, "W15"), //  보관자

              facilityNumber: this.getCellData(sheetData, "X4"), //시설물번호
              managementNumber: this.getCellData(sheetData, "X5"), //관리번호
              facilityName: this.getCellData(sheetData, "X6"), //시설물명
              routeDivision: this.getCellData(sheetData, "Z20"), //노선-구분
              routeDetail: this.getCellData(sheetData, "AE20"), //노선-세부노선

              facility_category_id: facilityCategory.id,
              // 시설물 구분
              cat1: facilityCategory.cat1,
              // 시설물 종류
              cat2: facilityCategory.cat2,
              cat3: facilityCategory.cat3,
              // 시설물 종별
              classification: facilityCategory.classification,

              socEvaluationTarget: this.getCellData(sheetData, "AZ20"), //SOC성능평가대상
              address: addresses.join(" "), //주소
              management_entity: this.getCellData(sheetData, "W13"), //관리주체
              management_type: 관리주체구분, //관리주체구분
              owner: this.getCellData(sheetData, "W14"), //소유자
              ownerType: 소유자구분, //소유자구분
              businessPlanApprovalDate: this.setMoment(this.getCellData(sheetData, "B27")), //사업계획승인일
              completionDate: this.setMoment(this.getCellData(sheetData, "G27")), // 준공일
              defectLiabilityExpirationDate1: this.setMoment(this.getCellData(sheetData, "P27")), // 하자보수책임만료일
              detailedSpecifications: this.getCellData(sheetData, "V27"), // 상세제원
              safetyInspectionAndDiagnosisHistory: this.getCellData(sheetData, "Y27"), // 안전점검진단이력
              repairAndReinforcementHistory: this.getCellData(sheetData, "AF27"), // 보수보강이력
              accessibleVentCover: this.getCellData(sheetData, "AK27"), // 접근가능한통풍구
              designPeriod: this.convertPeriodDate(this.getCellData(sheetData, "B29")), // 설계기간
              designer: this.getCellData(sheetData, "R29"), // 설계자
              constructionPeriod: this.convertPeriodDate(this.getCellData(sheetData, "AA29")), // 시공기간
              contractor: this.getCellData(sheetData, "AJ29"), // 시공자
              totalConstructionCost: this.getCellData(sheetData, "AV29"), // 총공사비
              seismicDesignTarget: this.getCellData(sheetData, "E31"), // 내진설계 대상 유무
              seismicDesignApplication: this.getCellData(sheetData, "R31"), // 내진설계 적용 유무
              seismicDesignStandard: this.getCellData(sheetData, "AA31"), // 적용내진설계기준
              seismicPerformanceEvaluation: this.getCellData(sheetData, "AJ31"), // 내진성능평가 실시 유무
              seismicReinforcement: this.getCellData(sheetData, "AV31"), // 내진보강 유무
              young21Target: this.getCellData(sheetData, "B33"), // 청년21대상
              auditPeriod: this.convertPeriodDate(this.getCellData(sheetData, "E33")), // 감리기간
              auditor: this.getCellData(sheetData, "R33"), // 감리자
              projectOwner: this.getCellData(sheetData, "AA33"), // 사업주체(발주자)
              constructionName: this.getCellData(sheetData, "AJ33"), // 공사명
              constructionSupervisor: this.getCellData(sheetData, "AV33"), // 공사감독·공사관리관
              creationDate: this.setMoment(this.getCellData(sheetData, "B36")), // 작성일
              author: this.$store.state.auth.userInfo ? this.$store.state.auth.userInfo.name : this.getCellData(sheetData, "N36"), // 작성자
              signature: "", // 서명
              lastModifiedDate: this.setMoment(this.getCellData(sheetData, "AB36")), // 최종수정일
              lastModifiedBy: this.getCellData(sheetData, 'AP36'), // 최종수정자
              remarks: this.getCellData(sheetData, "D37"), // 비고

              // 상세제원(청사)
              주용도: this.getCellData(sheetData, "K41"),
              세대수_주택: this.getCellData(sheetData, "U41"),
              층별용도: this.getCellData(sheetData, "AD41"),
              기타용도: this.getCellData(sheetData, "AM41"),
              층수_지상: this.getCellData(sheetData, "B44"),
              층수_옥탑: this.getCellData(sheetData, "K44"),
              층수_지하: this.getCellData(sheetData, "U44"),
              층수_최고높이: this.getCellData(sheetData, "AD44"),
              최고층고_높이: this.getCellData(sheetData, "AM44"),
              최고층고_해당층: this.getCellData(sheetData, "AX44"),
              구조형식: this.getCellData(sheetData, "B46"),
              지정형태: this.getCellData(sheetData, "U46"),
              기초형식: this.getCellData(sheetData, "AM46"),
              // detail
              기초밑면_깊이: this.getCellData(sheetData, "B48"),
              대지면적: this.getCellData(sheetData, "K48"),
              건축면적: this.getCellData(sheetData, "U48"),
              건축_연면적: this.getCellData(sheetData, "AD48"),
              건폐율: this.getCellData(sheetData, "AM48"),
              용적율: this.getCellData(sheetData, "AX48"),
              설계지하수위: this.getCellData(sheetData, "B51"),
              콘크리트_설계강도: this.getCellData(sheetData, "K51"),
              철근강도: this.getCellData(sheetData, "U51"),
              철골강도: this.getCellData(sheetData, "AD51"),
              방수공법_지붕층: this.getCellData(sheetData, "AM51"),
              방수공법_지하층: this.getCellData(sheetData, "AX51"),
              // 주차
              주차면적: this.getCellData(sheetData, "F53"),
              옥내주차면적: this.getCellData(sheetData, "M53"),
              옥외주차면적: this.getCellData(sheetData, "S53"),
              주차대수: this.getCellData(sheetData, "X53"),
              옥내주차대수: this.getCellData(sheetData, "AD53"),
              옥외주차대수: this.getCellData(sheetData, "AI53"),
              일시최대_사용인원: this.getCellData(sheetData, "AN53"),
              일일_사용인원: this.getCellData(sheetData, "BA53"),
              // 설비
              환기_공조_방식: this.getCellData(sheetData, "F56"),
              기계식일경우_배기닥트유무: this.getCellData(sheetData, "M56"),
              물탱크_위치: this.getCellData(sheetData, "S56"),
              변전실_위치: this.getCellData(sheetData, "X56"),
              유류저장_시설위치: this.getCellData(sheetData, "AD56"),
              오수정화_시설위치: this.getCellData(sheetData, "AI56"),
              승객용_승강기대수: this.getCellData(sheetData, "AN56"),
              화물용_승강기대수: this.getCellData(sheetData, "AT56"),
              비상용_승강기대수: this.getCellData(sheetData, "BA56"),

              중앙냉방_냉방유무: this.getCellData(sheetData, "F59"),
              중앙냉방_냉방열원: this.getCellData(sheetData, "M59"),
              중앙난방_난방유무: this.getCellData(sheetData, "AD59"),
              중앙난방_난방열원: this.getCellData(sheetData, "AI59"),
              전기인입용량: this.getCellData(sheetData, "BA59"),

              정화조_형식: this.getCellData(sheetData, "F61"),
              건물유지관리시스템: this.getCellData(sheetData, "S61"),
              유지관리_부대시설: this.getCellData(sheetData, "AD61"),
              승강기_운영방식: this.getCellData(sheetData, "AN61"),

              otherSpecifications: this.getCellData(sheetData, "M62"), // 기타제원

              companyList: [],
              photoList: [],
            },
            categoryInfo: {
              facility_category_id: facilityCategory.id,
              cat1: facilityCategory.cat1,
              cat2: facilityCategory.cat2,
              cat3: facilityCategory.cat3,
              classification: facilityCategory.classification,
            },
          });
        };
        reader.readAsArrayBuffer(file);
      }
    },
    getCellData(sheet, cell, key = "v") {
      // sheet[row]가 존재하고, 해당 cell 존재하는지 확인
      // sheet[cell].v : Raw value
      // sheet[cell].w : Formatted value
      // sheet[cell].t : Type
      if (sheet[cell] !== undefined) {
        return sheet[cell][key];
      } else {
        return "";
      }
    },
    inputDetail(data) {
      this.editExcelData.form = data;
    },
    onClickEditExcelData(index) {
      this.editExcelIndex = index;
      this.editExcelData = JSON.parse(JSON.stringify(this.excelData[index]));
    },
    onClickRemoveExcelData(index) {
      this.excelData.splice(index, 1);
    },
    onClickFinishExcelData(/*index*/) {
      // this.$set(this.excelData, index, this.editExcelData);
      this.editExcelIndex = null;
      this.editExcelData = null;
    },
    onClickCancelExcelData(/*index*/) {
      this.editExcelIndex = null;
      this.editExcelData = null;
    },

    /**
       * 1978-01-01 ~ 1981-12-31 형태의 문자열을 받아서 sDate, eDate로 나눠서 리턴한다
       *
       * @param dateStr
       * @returns {{sDate: string, eDate: string}}
       */
    convertPeriodDate(dateStr) {
      const result = { sDate: "", eDate: "" };
      if (dateStr) {
        // designPeriodStr 값을 '~' 기호로 분리한다
        const periodArr = dateStr.split("~");
        // 만약 2개가 나온다면, 각각 트림하여 designPeriod에 sDate, eDate로 넣어준다
        if (periodArr.length === 2) {
          result.sDate = periodArr[0].trim();
          result.eDate = periodArr[1].trim();
        }
      }
      return result;
    },
    onClickSave() {
      // 엑셀 데이터가 없을때 에러
      if (this.excelData.length < 1) {
        this.$emit("customAlert", `${this.label} 정보가 없습니다`);
        return;
      }

      const posts = this.excelData.map((ed) => {
        const option = {
          project_id: this.projectId, // 프로젝트 ID
          field_name: ed.form.facilityName, // 현장(시설물, 사업장) 이름
          contract_code: ed.form.facilityNumber, // 계약번호
          address: ed.form.address, // 주소
          phone: ed.form.phoneNumber, // 대표번호
          be_completed_at: ed.form.completionDate, // 준공일
          deposit_amount: ed.form.totalConstructionCost, // 총공사비
        };

          // Category
        if (typeof ed.form.cat4 === "number") {
          option.facility_category_id = ed.form.cat4;
        }

        // Company
        if (ed.row.관리부서및업체지정.length > 0) {
          option.company_ids = ed.row.관리부서및업체지정.map((com) => com.id);
        }

        // Meta
        option.meta = { ...ed.form };

        return option;
      });

      this.$emit("save", posts);
    },
    // 정렬 후 기타, 기타 외를 배열의 마지막으로 이동하는 함수
    setCatOther(list) {
      list.sort();

      const etcIndex = list.indexOf("기타");
      if (etcIndex > -1) {
        list.splice(etcIndex, 1);
        list.push("기타");
      }
      const etcOutIndex = list.indexOf("기타 외");
      if (etcOutIndex > -1) {
        list.splice(etcOutIndex, 1);
        list.push("기타 외");
      }

      return list;
    },
    setMoment(date) {
      return DateUtil.excelCellToYYYYMMDD(date);
    },
  },
};
</script>

  <style scoped lang="scss">
  table {
    table-layout: fixed;
    width: 100%;
    border-collapse: collapse;

    thead {
      th {
        text-align: center;
      }
    }

    th,
    td {
      padding: 0;
    }

    th {
      font-weight: 700;
      font-size: 14px;
      line-height: 17px;

      background: #fafafa;
      border-top: 1px solid #cdcdcd;
      border-bottom: 1px solid #cdcdcd;
      padding: 16px 0;
    }

    td {
      font-weight: 400;
      font-size: 14px;
      line-height: 17px;

      border-bottom: 1px solid #cdcdcd;
      padding: 16px 0;
    }

    .sub-table {
      th {
        background: #7e72f20d;
        border-top: 0;
        padding: 16px 10px;
      }
    }

    button {
      width: 32px;
      height: 32px;

      display: flex;
      align-items: center;
      justify-content: center;

      color: #7e72f2;
      background: none;
      border: 1px solid #7e72f2;
      border-radius: 4px;
      cursor: pointer;

      span {
        margin: 0;
      }
    }

    .check {
      justify-content: center !important;
      ::v-deep {
        span {
          margin: 0;
        }
      }
    }
  }

  .errMsg {
    font-weight: 400;
    font-size: 12px;
    line-height: 17px;
    text-align: center;
    color: #ea5455;
    margin-top: 2px;
  }
  </style>
